import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { environment } from '../../../../../environments/environment';
import {
  Cintillo,
  hasCintilloPromocionesActivas,
  mapPromocionesApiToCintillo,
  PromocionesApiResponse
} from '../../../../entities/cintillo/imagenes';

@Injectable({ providedIn: 'root' })
export class ImagenesService {
  private promocionesActivas$?: Observable<Cintillo | null>;

  constructor(private http: HttpClient) {}

  /** null si el API no trae las 3 URLs válidas (p. ej. promocionUno/Dos/Tres en null). */
  getPromociones(): Observable<Cintillo | null> {
    if (!this.promocionesActivas$) {
      this.promocionesActivas$ = this.http
        .get<PromocionesApiResponse>(`${environment.API_SECURITY}/Promociones`)
        .pipe(
          map((raw) => {
            const cintillo = mapPromocionesApiToCintillo(raw);
            return hasCintilloPromocionesActivas(cintillo) ? cintillo : null;
          }),
          catchError(() => of(null)),
          shareReplay(1)
        );
    }
    return this.promocionesActivas$;
  }
}
